$(document).ready(function(){
    
	$('#review-slider-carousel').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 300,
        autoplay:true,
		nav:false,
		pagination:false,  dots: false,
		navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:3
	        },
	        1100:{
	            items:3
	        }
	    }
	}); 

  jQuery(".accordion-heading").click(function(e){
      if(!$(this).closest(".accordion-box").hasClass("open"))
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
      $(this).closest(".accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".accordion-box").toggleClass("open");
    }
    else
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
    }
  });

  //Product Tabing JS

  $(document).on("click",".tab-btn",function(){
  var id_tab=$(this).attr("data-val");
  $(".tab-btn").removeClass("active");
  $(this).addClass("active");
  
  $(".product-tab-body").removeClass("active");
  $(".product-tab-body."+id_tab).addClass("active");
});
	 
});


$(document).ready(function() {
    var video = $('.video-text-area .right-video video').get(0);
    var playPauseIcon = $('#playPauseIcon');

    playPauseIcon.click(function() {
        if (video.paused) {
            video.play();
            playPauseIcon.hide(); 
        } else {
            video.pause();
            playPauseIcon.show(); 
        }
    });

    video.onpause = function() {
        playPauseIcon.show(); 
    };

    video.onplay = function() {
        playPauseIcon.hide(); 
    };
});





